<template>
  <dx-grid
    name="portal-errors"
    :url="url"
    :columns="columns"
    title="Portal Errors"
    :pageSize="50"
    :requestTimeout="120000"
    :expandedOptions="{
      enabled: true,
      template: 'portal-error-details',
    }"
  ></dx-grid>
</template>

<script>
import moment from "moment";

function column(label, field, extra) {
  return Object.assign(
    {
      label: label,
      field: field,
      visible: true,
      allowHeaderFiltering: false,
      filterValues: [],
      filterValue: null,
      selectedFilterOperation: null,
    },
    extra || {}
  );
}

export default {
  data: () => ({
    url:
      "errorLogs?$select=id,date,username,errorMessage,requestURL,requestMethod,statusCode,source",
    columns: [
      column("Date", "date", {
        type: "date",
        format: "MM/dd/yyyy hh:mm:ss a",
        sortOrder: "desc",
        sortIndex: 0,
        filterValue: moment()
          .subtract(7, "days")
          .startOf("day")
          .toDate(),
        selectedFilterOperation: ">=",
      }),
      column("User", "username"),
      column("Source", "source"),
      column("Status", "statusCode"),
      column("Method", "requestMethod"),
      column("URL", "requestURL"),
      column("Error", "errorMessage"),
    ],
  }),
};
</script>
